import dom, { Fragment } from "../../dist/jsx-render/dom"
import { GridViewSelectPopup } from "./GridViewSelect/GridViewSelectPopup";
import { IClientGridView } from "./GridViewSelect/IClientGridView";
import { app } from "./App";
import { SortCondition } from "../Pages/Measure/VisibilityDependency/SortCondition";
import { DropdownSubMenus } from "../Common/DropdownMenu";
import { AsyncLocalStorage } from "async_hooks";
import { IListItem } from "../Model/IListItem";
import { IReportListItem } from "../Model/IReportListItem";
import { MsoTable } from "../Controls/Table/MsoTable";
import { DynPopup } from "../Components/DynPopup";

export class GridViewSelect {
    static instances: GridViewSelect[];

    public onViewChanged: (id: string) => void;
    public postViewChanged: (id: string) => void;
    private model: IClientGridView;
    private dontChangeUserView: boolean;
    private button: HTMLButtonElement;
    private dataTemplateId: number;
    private editingScenario: boolean;

    public constructor(element: HTMLElement, model?: IClientGridView, private repositionDropdown: boolean = false) {
        if (model) {
            this.model = model;
        }
        else {
            this.model = JSON.parse((document.getElementById(element.id + "_model") as HTMLInputElement).value);
        }

        // create control
        this.createDropdown(element);

        let changeUserViewAttr = element.getAttribute("data-dont-change-user-view");
        this.dontChangeUserView = changeUserViewAttr == "true";

        if (!GridViewSelect.instances) {
            GridViewSelect.instances = [];
        }
        GridViewSelect.instances.push(this);

        let dataTemplateId = element.getAttribute("data-data-template-id");
        if (dataTemplateId) {
            this.dataTemplateId = Number(dataTemplateId);
        }

        let editingScenario = element.getAttribute("data-editing-scenario");
        if (editingScenario == "true") {
            this.editingScenario = true;
        }
    }

    dropdownMenu: HTMLElement;

    protected createDropdown(element: HTMLElement): void {
        let hasAdministrativeLists : boolean = false;
        if (this.model.allViews.some(i => i.isActivity === true)) {
            hasAdministrativeLists  = true;
        }

        let listViewClusters: string[] = [];
        this.model.allViews.map(l => {
            if (!l.isActivity && l.groupName && !listViewClusters.includes(l.groupName)) {
                listViewClusters.push(l.groupName);
            }
        })

        this.button = <button className="btn btn-custom btn-mso pag-button pointer" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-view-name={this.model.name}>
            {this.model.isPublic ?
                <i className="far fa-users mr-2"></i>
                :
                <i className="far fa-key mr-2"></i>
            }
            {this.model.name}
        </button>;

        element.classList.add("dropdown");
        element.appendChild(
            <Fragment>
                {this.button}
                <div className="dropdown-menu">
                    {this.renderEditMenuItem()}
                    {this.renderCopyMenuItem()}
                    {this.renderNewMenuItem()}
                    {this.renderDeleteMenuItem()}
                    {this.renderResetMenuItem()}
                    <div className="dropdown-divider"></div>
                    {hasAdministrativeLists 
                        ? this.renderAdministrativeItem()
                        : []}
                    {...this.renderClusteredViewLinks(listViewClusters)}
                    {...this.renderViewLink()}
                </div>
            </Fragment>
        );

        this.dropdownMenu = element.getElementsByClassName("dropdown-menu").item(0) as HTMLElement;

        if (this.repositionDropdown) {
            // see https://stackoverflow.com/questions/31829312/bootstrap-dropdown-clipped-by-overflowhidden-container-how-to-change-the-conta
            $(element).on('show.bs.dropdown', () => {
                document.body.appendChild(this.dropdownMenu);
            });

            $(element).on('hidden.bs.dropdown', () => {
                element.appendChild(this.dropdownMenu);
            });
        }

        let subMenus = new DropdownSubMenus();
        subMenus.init(element);
    }

    private renderClusteredViewLinks(clusters: string[]): HTMLElement[] {
        let result: HTMLElement[] = [];
        let index: number = 0;
        if (clusters && clusters.length !== 0) {
            clusters.map(c => {
                index++;
                let elementName = "clouster_" + index.toString(); 
                result.push(
                    <div className="dropdown-submenu dropleft" data-child-menu={elementName} >
                        <a className="dropdown-item dropdown-toggle pointer" data-id="0">
                            <i className="fas fa-caret-left mr-2" data-id="0"></i>
                            {c}
                        </a>
                    </div>)

                let subMenu: HTMLElement = <div className="max-height-fill-available dropdown-menu child-menu" data-menu-name={elementName} use-max-height></div>;

                for (let view of this.model.allViews.filter(v => !v.isActivity && v.groupName === c)) {
                    let viewLink: HTMLElement = <a className="dropdown-item pointer" data-id={view.id}>
                        {view.name}
                    </a>;

                    viewLink.addEventListener("click", this.onChange);
                    subMenu.appendChild(viewLink);
                }

                document.body.appendChild(subMenu);
            });
        }
       

        return result;
    }

    protected renderViewLink(): HTMLElement[] {
        let result: HTMLElement[] = [];
        for (let item of this.model.allViews.filter(v => !v.isActivity && !v.groupName)) {
            result.push(
                <a className="dropdown-item pointer" href="#" data-id={item.id} data-view data-name={item.name}>
                    {item.parentId == 1 ?
                        <i className="far fa-users mr-2" data-id={item.id}></i>
                        :
                        <i className="far fa-key mr-2" data-id={item.id}></i>
                    }
                    {item.name}
                </a>
            );
        }
        for (let item of result) {
            item.addEventListener("click", this.onChange);
            (item.firstElementChild as HTMLElement)?.addEventListener("click", this.onChange);
        }
        return result;
    }

    protected renderAdministrativeItem = (): HTMLElement => {
        let activityLink =
            <div className="dropdown-submenu dropleft" data-child-menu="activities">
                <a className="dropdown-item dropdown-toggle pointer" data-id="0">
                    <i className="fas fa-caret-left mr-2" data-id="0"></i>
                    {Resources.Common.administrativeLists}
                </a>
            </div>

        let subMenu: HTMLElement = <div className="max-height-fill-available dropdown-menu child-menu" data-menu-name="activities" use-max-height></div>;

        for (let view of this.model.allViews.filter(v => v.isActivity === true)) {
            let viewLink: HTMLElement = <a className="dropdown-item pointer" data-id={view.id}>
                {view.name}
            </a>;

            viewLink.addEventListener("click", this.onChange);
            subMenu.appendChild(viewLink);
        }

        document.body.appendChild(subMenu);

        return activityLink;
    }

    protected renderEditMenuItem(): HTMLElement {
        if ((!this.model.isPublic || this.model.canEditPublicView) && !this.model.notEditable) {
            let item: HTMLElement = <a className="dropdown-item pointer" data-view-type data-type="edit" data-id={this.model.id} data-art={this.model.art} data-create-public={this.model.canEditPublicView ? "true" : "false"}><i className="far fa-edit mr-2"></i>{Resources["Common"].viewEdit}</a>;
            item.addEventListener("click", this.onEdit);
            return item;
        }
        return null;
    }

    protected renderCopyMenuItem(): HTMLElement {
        let item: HTMLElement = <a className="dropdown-item pointer" data-view-type data-type="copy" data-id={this.model.id} data-create-public={this.model.canEditPublicView ? "true" : "false"}><i className="far fa-clone mr-2"></i>{Resources["Common"].viewCopy}</a>;
        item.addEventListener("click", this.onCopy);
        return item;
    }

    protected renderNewMenuItem(): HTMLElement {
        let item: HTMLElement = <a className="dropdown-item pointer" data-view-type data-type="new" data-id={this.model.id} data-art={this.model.art} data-create-public={this.model.canEditPublicView ? "true" : "false"}><i className="far fa-plus mr-2"></i>{Resources["Common"].viewCreate}</a>;
        item.addEventListener("click", this.onNew);
        return item;
    }

    protected renderDeleteMenuItem(): HTMLElement {
        if (this.model.canDeleteCurrentView && !this.model.notEditable) {
            let item: HTMLElement = <a className="dropdown-item pointer" data-view-type data-type="delete" data-id={this.model.id}><i className="far fa-trash mr-2"></i>{Resources["Common"].viewDelete}</a>;
            item.addEventListener("click", this.onDelete);
            return item;
        }
    }

    protected renderResetMenuItem(): HTMLElement {
        if (!this.model.notEditable) {
            let item: HTMLElement = <a className="dropdown-item pointer" data-view-type data-type="reset" data-id={this.model.id}><i className="fal fa-sync mr-2"></i>{Resources["Common"].viewReset}</a>;
            item.addEventListener("click", this.onReset);
            return item;
        }
    }

    onEdit = (ev: MouseEvent) => {
        (ev.target as HTMLElement)

        const popup = new GridViewSelectPopup({
            model: this.model,
            isCopy: false,
            isNew: false,
            dontChangeUserView: this.dontChangeUserView,
            canCreatePublic: (ev.target as HTMLElement).getAttribute("data-create-public") === "true",
            onViewChanged: this.onViewChanged,
            postSaveHandler: this.postSaveHandler,
            dataTemplateId: this.dataTemplateId,
            editingScenario: this.editingScenario
        });
        document.body.appendChild(popup.render());
    }

    onCopy = (ev: MouseEvent) => {
        const popup = new GridViewSelectPopup({
            model: this.model,
            isCopy: true,
            isNew: false,
            dontChangeUserView: this.dontChangeUserView,
            canCreatePublic: (ev.target as HTMLElement).getAttribute("data-create-public") === "true",
            onViewChanged: this.onViewChanged,
            postSaveHandler: this.postSaveHandler,
            dataTemplateId: this.dataTemplateId,
            editingScenario: this.editingScenario
        });
        document.body.appendChild(popup.render());
    }

    onNew = (ev: MouseEvent) => {
        let newModel: IClientGridView = {
            id: 0,
            name: "",
            fields: [],
            available: this.model.available,
            art: parseInt((ev.target as HTMLElement).getAttribute("data-art")),
            artString: this.model.artString,
            childViewId: 0,
            useChildViews: true,
            filters: [],
            sorts: new SortCondition(),
            isPublic: true,
            isAdministrative: false,
            views: this.model.views,
            viewIndex: 0,
            useAvatars: false,
            singleLineDisplay: false,
            resultLineDisplay: false,
            hideDuplicatesOption: false,
            inlineEdit: false,
            canDeleteCurrentView: this.model.canDeleteCurrentView,
            canEditPublicView: this.model.canEditPublicView,
            useInlineEdit: this.model.useInlineEdit,
            allViews: [],
            newMeasureTemplateIds: this.model.newMeasureTemplateIds,
            rowClickUrl: null,
            rowClickUrlUsePopup: false,
            showOnlySelectedReporting: false,
            showOnlySelectedExcel: false,
            hideButtonExport: false,
            selectedExcelTemplates: [],
            selectedReports: [],
            notEditable: this.model.notEditable,
            groupName: "",
            dataTemplateId: this.dataTemplateId,
            editingScenario: this.editingScenario
        };

        const popup = new GridViewSelectPopup({
            model: newModel,
            isCopy: false,
            isNew: true,
            dontChangeUserView: this.dontChangeUserView,
            canCreatePublic: (ev.target as HTMLElement).getAttribute("data-create-public") === "true",
            onViewChanged: this.onViewChanged,
            postSaveHandler: this.postSaveHandler,
            dataTemplateId: this.dataTemplateId,
            editingScenario: this.editingScenario
        });
        document.body.appendChild(popup.render());
    }

    onChange = (ev: MouseEvent) => {
        ev.stopPropagation();
        ev.preventDefault();
        const id = (ev.target as HTMLElement).getAttribute("data-id");
        let name = (ev.target as HTMLElement).textContent;
        if (this.dontChangeUserView) {

            app.showWaitPanel();

            if (this.onViewChanged) {
                this.onViewChanged(id);
            } else {
                // TODO Define what should happen, if there is no event handler set.
            }

            // Close Dropdown (No idea why this doesn't happen automatically)
            this.postSaveHandler(name, id);
        } else {

            $.ajax({
                type: "POST",
                url: app.resolveUrl("~/api/gridView/change/" + id + "/" + this.model.viewIndex),
                success: (() => {
                    if (this.onViewChanged) {
                        this.onViewChanged(id);
                    }
                    else {
                        if (location.search.length !== 0) {
                            //Remove query string
                            location.search = '';
                        } else {
                            location.reload();
                        }
                    }
                }),
                error: ((response) => {
                    alert(response.statusText + ": " + response.responseText);
                })
            });
        }
    }

    onDelete = (ev: MouseEvent) => {
        let id = (ev.target as HTMLElement).getAttribute("data-id");

        $.ajax({
            type: "POST",
            url: app.resolveUrl("~/api/gridView/delete/" + id),
            success: (data) => {
                if (this.onViewChanged) {
                    this.onViewChanged(id);
                }
                else {
                    location.reload();
                }
            },
            error: (err) => {
                alert(err.statusText + ": " + err.responseText);
            }
        });
    }

    onReset = (ev: MouseEvent) => {
        let id = (ev.target as HTMLElement).getAttribute("data-id");
        
        

        // Get the table that belongs to this GridViewSelect
        for (let key in MsoTable.allTables) {
            let table = MsoTable.allTables[key];

            // This assumes there will only ever be one table with a specific AnsichtArt on any given page.
            if (table.props.viewType == this.model.artString) {
                // delete local storage for this view
                window.localStorage.removeItem(`TableView_${this.model.artString}_${this.model.id}`);

                DynPopup.ShowDialog(Resources.Common.viewResetDone, (event: Event) => { location.reload(); });
            }
        }
    }

    public closeDropdown = () => {
        this.button.setAttribute("aria-expanded", "false");
        this.dropdownMenu.classList.remove("show");
        this.dropdownMenu.attributes.removeNamedItem("style");
    }

    private loadJsonModel = (viewId: string) => {
        $.ajax({
            url: app.resolveUrl(`~/api/GridView/getClientGridViewByViewId/${viewId}`),
            method: "GET",
            success: (clientGridView: IClientGridView) => {
                this.model = clientGridView;
                this.recreateReportButtons();

                if (this.postViewChanged) {
                    this.postViewChanged(viewId);
                } else {
                    app.hideWaitPanel();
                }
            },
            error: (err) => {
                console.log(err);
            }
        });
    }

    private postSaveHandler = (name: string, id: string) => {
        this.closeDropdown();

        // Show the selected view as current view (this is achieved by reloading the page, if dontChangeUserView == false)
        this.button.textContent = name;

        // Load the json model of the current view
        this.loadJsonModel(id);
    }

    private recreateReportButtons = () => {
        // Apply selected Reports for view
        let buttonExportPrint = document.querySelector(".listview-print-dropdown") as HTMLElement;
        if (buttonExportPrint) {

            let allowedReports: IReportListItem[];
            // Collect allowed reports
            if (this.model.showOnlySelectedReporting) {
                allowedReports = this.model.availableReports.filter(r => this.model.selectedReports.indexOf(r.id) > -1);
            } else {
                allowedReports = this.model.availableReports;
            }

            let allowedExcel: any[];
            if (this.model.showOnlySelectedExcel) {
                allowedExcel = this.model.availableExcelTemplates.filter(e => this.model.selectedExcelTemplates.indexOf(e.id) > -1);
            } else {
                allowedExcel = this.model.availableExcelTemplates;
            }

            app.destroyDomChildren(buttonExportPrint);
            buttonExportPrint.appendChild(
                <Fragment>
                    <div className="dropdown-submenu dropright">
                        <a className="dropdown-item dropdown-toggle pointer">{Resources.Common["print"]}</a>
                        {allowedReports.length > 0
                            ? <ul class="dropdown-menu">
                                {allowedReports.map(r =>
                                    <li class="sub-menu-item">
                                        <a class="report-view-item dropdown-item pointer" data-id={r.id} data-output={r.output}>{r.name}</a>
                                    </li>)}
                            </ul>
                            : []}
                    </div>
                    <div class="dropdown-submenu dropright">
                        <a className="dropdown-item dropdown-toggle pointer">{Resources.Common["export"]}</a>
                        {allowedExcel.length > 0
                            ? <ul class="dropdown-menu">
                                {allowedExcel.map(e =>
                                    <li class="sub-menu-item">
                                        <a class="export-view-item dropdown-item pointer" data-id={e.id}>{e.name}</a>
                                    </li>)}
                            </ul>
                            : []}
                    </div>
                </Fragment>
            );

            let subMenus = new DropdownSubMenus();
            subMenus.init(buttonExportPrint);
        }
    }
}